<template>
  <Modal v-if="modal.address" @close="closeListModal" class="change-address-modal">
    <div class="modal-header" v-if="type === 'edit'">주소지 관리</div>
    <div class="modal-header" v-else>주소지 불러오기</div>
    <div class="modal-body text-center">
      <ul class="address-list" v-if="addressList && addressList.length > 0">
        <li v-for="(item, idx) in addressList" :key="`address_${item.id}`">
          <div class="title">
            주소록 {{ idx + 1 }}
            <button v-if="type === 'edit'" class="btn btn-primary no-animate btn-xs btn-edit-address" @click="showUpdateAddressModal(idx)">수정</button>
            <button v-else-if="type === 'load'" class="btn btn-border-black no-animate btn-xs btn-edit-address" @click="selectAddress(idx)">선택</button>
          </div>
          <p class="address">{{ item.address }}</p>
          <p class="address address-detail">{{ item.address_detail || ''}} <span v-if="!isHideFloor">{{ $helper.getFloorTxt(item.address_floor) || '' }}층</span></p>
        </li>
      </ul>
      <p v-else-if="type === 'load'">등록된 주소지가 없습니다. <br><router-link to="/my/profile" target="_blank">마이페이지</router-link>에서 자주쓰는 주소를 추가해보세요</p>
      <p v-else>등록된 주소지가 없습니다. <br>주소를 추가해보세요!</p>
    </div>
    <div v-if="type === 'edit'" class="modal-footer">
      <button class="btn btn-md btn-primary-v2 btn-block" @click="showAddAddressModal">주소지 추가</button>
    </div>
  </Modal>

  <Modal v-if="modal.address_target" @close="modal.address_target = false; resetAddress()" class="change-address-modal">
    <div class="modal-header">{{ selectedAddress ? '주소지 수정' : '주소지 추가' }}</div>
    <div class="modal-body">
      <TheEstimateStepForAddress v-if="selectedAddress"
                                 :is-hide-title="true" dir="all"
                                 v-model:address="selectedAddress.address"
                                 v-model:address_detail="selectedAddress.address_detail"
                                 v-model:sigungu="selectedAddress.address_sigungu"
                                 v-model:bname="selectedAddress.address_bname"
                                 v-model:zipcode="selectedAddress.address_zipcode"
                                 :keypressEnter="saveAddress"
      >
        <template v-slot:side>
          <input type="number" class="input floor-input" placeholder="층수" v-model="selectedAddress.address_floor" @keydown.enter.tab="saveAddress">
        </template>
      </TheEstimateStepForAddress>
      <TheEstimateStepForAddress v-else
                                 :is-hide-title="true" dir="all"
                                 v-model:address="address.address"
                                 v-model:address_detail="address.address_detail"
                                 v-model:sigungu="address.address_sigungu"
                                 v-model:bname="address.address_bname"
                                 v-model:zipcode="address.address_zipcode"
                                 :keypressEnter="saveAddress"
      >
        <template v-slot:side>
          <input type="number" class="input floor-input" :class="{ hide: !address.address }" placeholder="층수" v-model="address.address_floor" @keydown.enter.tab="saveAddress">
        </template>
      </TheEstimateStepForAddress>
    </div>
    <div class="modal-footer">
      <button class="btn btn-md btn-primary-v2 btn-block " @click="saveAddress">저장</button>
      <button v-if="this.selectedAddress" class="btn btn-md btn-border-grey-v2 btn-block mt-2 " @click="deleteAddress" >삭제</button>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import apiUser from "@/api/user";
import TheEstimateStepForAddress from "@/components/estimate/TheEstimateStepForAddress";
export default {
  name: "TheAddressModal",
  components: {
    Modal,
    TheEstimateStepForAddress,
  },
  props: ['type', 'onSelectedAddress', 'key', 'isHideFloor'],
  data() {
    return {
      modal: {
        address: false,
        address_target: false,
      },
      addressList: [],
      address: {
        address: '',
        address_detail: '',
        address_sigungu: '',
        address_bname: '',
        address_zipcode: '',
        address_floor: ''
      },
      selectedAddress: null
    }
  },
  methods: {
    closeListModal() {
      this.modal.address = false;
    },
    showUpdateAddressModal(idx) {
      this.selectedAddress = this.addressList[idx];
      this.modal.address_target = true;
    },
    selectAddress(idx) {
      if (this.onSelectedAddress) {
        this.onSelectedAddress(this.addressList[idx], this.key);
      }
    },
    showAddAddressModal() {
      this.modal.address_target = true;
    },
    async saveAddress() {
      try {
        if (this.selectedAddress) {
          if (!this.validateAddress(this.selectedAddress)) return;
          await apiUser.updateAddress(this.selectedAddress.id, {
            address: this.selectedAddress.address,
            address_detail: this.selectedAddress.address_detail,
            address_sigungu: this.selectedAddress.address_sigungu,
            address_bname: this.selectedAddress.address_bname,
            address_zipcode: this.selectedAddress.address_zipcode,
            address_floor: this.selectedAddress.address_floor
          });
          alert("수정되었습니다.");
          this.$router.go();
        } else {
          if (!this.validateAddress(this.address)) return;
          await apiUser.addAddress(this.address);
          alert("추가되었습니다.");
          this.$router.go();
        }
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          alert(e.response.data.message);
        } else {
          alert("주소를 저장하는데 실패했습니다. 고객센터로 문의해주세요.");
        }
      }
    },

    resetAddress() {
      this.selectedAddress = null;
      this.address.address =  '';
      this.address.address_detail =  '';
      this.address.address_sigungu =  '';
      this.address.address_bname =  '';
      this.address.address_zipcode =  '';
      this.address.address_floor =  '';
    },

    validateAddress(data) {
      if (!data.address) {
        alert("주소가 누락되었습니다.");
        return false;
      }

      if (!data.address_detail) {
        alert("상세주소를 입력해주세요.");
        return false;
      }

      if (!data.address_floor) {
        alert("층수를 입력해주세요");
        return false;
      }

      if (data.address_floor < -5 || data.address_floor > 100) {
        alert("층수는 지하 5층부터 지상 100층까지 입력해주세요.");
        return false;
      }

      return true;
    },

    async deleteAddress() {
      if (window.confirm('정말 삭제하시겠습니까?')) {
        try {
          await apiUser.deleteAddress(this.selectedAddress.id);
          alert("삭제되었습니다.");
          this.$router.go();
        } catch (e) {
          if (e.response && e.response.data && e.response.data.message) {
            alert(e.response.data.message);
          } else {
            alert("주소를 삭제하는데 실패했습니다. 고객센터로 문의해주세요.");
          }
        }
      }
    },
    async showAddressModal() {
      try {
        this.$helper.sendGA('click_btn_address');
        this.addressList = await apiUser.getAddressList();
        this.modal.address = true;
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          alert(e.response.data.message);
        } else {
          alert("주소를 불러오는데 실패했습니다. 고객센터로 문의해주세요.");
        }
      }
    },
  }
}
</script>

<style scope lang="scss">

.address-list {
  list-style: none;
  text-align: left;
  line-height: 1.5;
  margin: 0;
  padding: 0;

  .title {
    font-weight: bold;
    padding-bottom: 10px;
  }

  p {
    margin: 0;
  }

  .btn-edit-address {
    border-radius: 5px;
    padding: 2px 10px 3px;
    margin-left: 5px;
    font-size: 13px;
  }

  li {
    margin-top: 10px;
    border-radius: 5px;
    padding: 15px;
    background-color: #f2f2f2;
  }
}

.floor-input {
  float: right;
  width: 90px;
  margin-top: 12px;
}

@include respond(mobile) {
  p {
    font-size: 14px;
  }

  .address-list {
    .btn-edit-address {
      padding: 3px 8px 4px;
      margin-top: 4px;
      margin-left: 5px;
      vertical-align: top;
      font-size: 10px;
    }
  }
}

</style>
<style lang="scss">
.change-address-modal {
  .input-detail-address {
    width: calc(100% - 100px);
  }

  .modal-body > p {
    line-height: 1.7;
    letter-spacing: -0.2px;
  }
}


@include respond(not-mobile) {
  .change-address-modal {
    .modal-window {
      min-width: 500px;
    }
  }
}

@include respond(mobile) {
  .change-address-modal {
    .modal-body {
      max-height: 65vh;
      overflow-y: auto;
    }
  }
}

</style>
